export const tableCustomStyles = {
  headCells: {
    style: {
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '13px',
      lineHeight: '100%',
      letterSpacing: '0%',
      color: '#838486',
    },
  },
};
